import { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Blendet Inhalte aus, für die dem Benutzer die Berechtigung fehlt.
 *
 * Das ist ausdrücklich KEIN Schutz -- der liegt im Backend. Es geht um
 * Ehrlichkeit der Oberfläche: ein Knopf, der beim Drücken 403 liefert,
 * ist schlechter als kein Knopf.
 */
export function Can({
  recht,
  alle,
  children,
  sonst = null,
}: {
  /** Ein Recht oder mehrere; bei mehreren genügt standardmäßig eines. */
  recht: string | string[];
  /** Alle genannten Rechte verlangen statt nur eines. */
  alle?: boolean;
  children: ReactNode;
  sonst?: ReactNode;
}) {
  const { hatRecht } = useAuth();
  const liste = [recht].flat();
  const erfuellt = alle ? liste.every(hatRecht) : liste.some(hatRecht);
  return <>{erfuellt ? children : sonst}</>;
}

/** Kurzform für Bedingungen im Code. */
export function usePermission(): {
  hatRecht: (schluessel: string) => boolean;
  hatEines: (...schluessel: string[]) => boolean;
  hatAlle: (...schluessel: string[]) => boolean;
} {
  const { hatRecht } = useAuth();
  return {
    hatRecht,
    hatEines: (...s) => s.some(hatRecht),
    hatAlle: (...s) => s.every(hatRecht),
  };
}

export default Can;
